<template>
  <div>
    <el-dialog title="文件存储" :visible.sync="fileDialog" width="980px">
      <div style="height: 480px;display: flex;">
        <el-menu :default-active="index.fileType">
          <el-menu-item v-for="item in fileTypes" :key="item.type" :index="item.type">{{ item.name }}</el-menu-item>
        </el-menu>
        <div style="width: 100%;margin-top: -56px">
          <el-button type="danger" icon="el-icon-upload" size="medium">上传</el-button>
          <el-input placeholder="搜索文件" style="width: 200px;margin:0 0 10px 10px" clearable size="medium"></el-input>
          <div class="flex justify-between align-center">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item v-for="item in folderRouter" :key="item.name" :index="item.id">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
              <el-button-group size="mini">
                <el-button type="primary" class="show-type" icon="el-icon-s-operation"
                    :plain="index.showType !== 1" @click="index.showType = 1"></el-button>
                <el-button type="primary" class="show-type" icon="el-icon-menu"
                    :plain="index.showType !== 2" @click="index.showType = 2"></el-button>
              </el-button-group>
          </div>
          <file-table :showType="index.showType"/>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FileTable from "./FileTable";
export default {
  name: "FileManager",
  components:{FileTable},
  data() {
    return {
      fileTypes:[{ name: "全部", type: "all"}, { name: "最近", type: "nearby"},
        { name: "图片", type: "image"}, { name: "音频", type: "music"}, { name: "视频", type: "video"},
        { name: "pdf", type: "pdf"}, { name: "word", type: "word"}, { name: "excel", type: "excel"}],
      folderRouter:[{name:"根目录",id:0}],
      index:{fileType:"all", header:[], showType:2},
      fileDialog: false,
      menu: 1
    };
  },
  methods:{
    setActive(index) {
      this.activeMenu = index;
    },
    openDialog(){
      this.fileDialog = true;
    }
  }
}
</script>

<style scoped>
.el-dialog__body{
  padding: 0;
}
.el-menu{
  margin-right: 20px;
  padding-right: 20px;
  width: 90px;
  height: 440px;
}

.el-menu-item{
  text-align: center;
  height: 50px;
  line-height: 50px;
}
.el-menu-item:hover {
  border-radius: 12px;
}
.el-menu-item.is-active {
  color: white;
  background-color: #ff4d4f !important;
  border-radius: 12px;
  text-align: center;
}
.show-type{
  font-size: 15px;padding:6px 9px
}
</style>



